import React from 'react'
import  ReactDOM  from 'react-dom'
import App from './App'
import './index.css'
// const index = () => {
//   return (
//     <div>index</div>
//   )
// }

ReactDOM.render(<React.StrictMode>
                    <App />
                </React.StrictMode>, 
document.getElementById('root'));